module.exports = __webpack_public_path__ + "img/6.dab3bdbe.png";